import Axios from 'axios';
import './cys.less';
import { PopupFactory } from '../../../common/components/popup/popup';
import { GlobalNotification } from '../../../common/components/global-notification/global-notification';
import { makeUrl } from '../../../utils/makeUrl';
import { addToCartRequest } from '../utils/addToCartRequest';
import { getProductData } from '../utils/data';
import { Preloader } from '../../../common/components/preloader/preloader';
import { updateMiniCart } from '../utils/updateMiniCart';
import { resolveUrl } from '../../../utils/resolveUrl';

/* eslint-disable */

function CarouselFactory(config) {
    if (config.targetElement === void 0 || config.parentContainer === void 0) {
        throw new Error('Provide elements for Carousel module');
    }
    var $container = $(config.parentContainer);
    var $target = $container.find(config.targetElement);

    function create(initialSlide, totalSlides) {
        var cfg = createResultedConfig(initialSlide || 0, totalSlides);
        $target.slick(cfg);
    }

    function createResultedConfig(initialSlide, totalSlides) {
        var mobileConfig =
            totalSlides > 2
                ? {
                      infinite: true,
                      slidesToShow: 1,
                      dots: true,
                      centerMode: true,
                      centerPadding: '85px',
                  }
                : {
                      infinite: true,
                      slidesToShow: 2,
                      dots: false,
                      centerMode: true,
                      centerPadding: '10px',
                  };

        var defaultConfig = {
            infinite: false,
            speed: 500,
            slidesToScroll: 1,
            appendArrows: $container,
            dots: false,
            slidesToShow: 3,
            swipeToSlide: true,
            prevArrow: '<a href="#" class="cys-slick-arrow cys-slick-prev" alt="Previous"></a>',
            nextArrow: '<a href="#" class="cys-slick-arrow cys-slick-next" alt="Next"></a>',
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        dots: true,
                        centerMode: true,
                        centerPadding: '60px',
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: mobileConfig,
                },
            ],
            initialSlide: initialSlide || 0,
        };

        return defaultConfig;
    }
    /**
     * Destroy Carousel
     */
    function destroy($carousel) {
        return ($carousel === void 0 ? $target : $carousel).slick('unslick');
    }
    return {
        create: create,
        destroy: destroy,
    };
}

function renderListItems(list, itemRenderer) {
    var contentParameters = {
        isSalePriceAvailable: list.some(item => item.salePrice),
        isPartnerDisplayNameAvailable: list.some(item => item.partnerDisplayName),
    };

    return list.reduce((fragment, item, index) => {
        fragment.appendChild(itemRenderer(item, contentParameters, index));
        return fragment;
    }, document.createDocumentFragment());
}

function CarouselItemsRenderer(config) {
    if (config.carouselElement === void 0 || config.wrapper === void 0) {
        throw new Error('Provide elements for carousel renerer');
    }
    const wrapperElement = document.querySelector(config.wrapper);
    let carouselElement = document.querySelector(config.carouselElement);

    function placeSliderShadow(shouldBePlaced) {
        if (shouldBePlaced) {
            return wrapperElement.classList.add('cys-carousel-shadow');
        }
        wrapperElement.classList.remove('cys-carousel-shadow');
    }

    const button = index => `
            <div class="cys-card-button">
                <button class="btn btn-primary btn-block"
                    data-item-index="${index}"
                >
                    ${getProductData().msgAddToCartText}
                </button>
            </div>
        `;

    const callButton = () => {
        var linkHref = 'tel: ' + config.dict.msgPhone.replace(/[\s\-\_]/g, '');
        return `
            <a class="cys-call-availability" href="${linkHref}" target="_blank" rel="noreferrer noopener nofollow">
                <span class="cys-call-availability--label">${config.dict.msgCallForStockText}</span>
                <span class="cys-call-availability--phone">${config.dict.msgPhone}</span>
            </a>
        `;
    };

    function renderItem(item, contentParameters, index) {
        const template = `
            <div class="cys-card-wrapper">
                <div class="cys-card-image">
                    <a class="slider-image-wrap" href="${config.urlResolver(item.productPageUrl)}"
                        style="background-image: url(${item.imageUrl})"
                    ></a>
                </div>
                <div class="cys-card-title">${item.productDisplayName}</div>
                ${
                    contentParameters.isSalePriceAvailable
                        ? `<div class="cys-striked-price">${
                              item.salePrice ? item.listPrice : ''
                          }</div>`
                        : ''
                }
                <div class="cys-card-price">${item.salePrice || item.listPrice || '--'}</div>
                ${
                    contentParameters.isPartnerDisplayNameAvailable
                        ? `<div class="cys-reseller-price-label">${
                              item.partnerDisplayName
                                  ? item.partnerDisplayName + ' ' + config.dict.resellerPriceLabel
                                  : ''
                          }</div>`
                        : ''
                }
                ${item.unavailable ? callButton() : button(index)}
            </div>
        `;
        const fragment = document.createElement('div');
        fragment.innerHTML = template;
        fragment.className = 'cys-card';
        fragment.setAttribute('data-sku-id', item.skuId);
        fragment.setAttribute('data-item-name', item.productDisplayNameTag || '');
        fragment.setAttribute('data-product-id', item.productId);
        fragment.setAttribute('data-price-no-tax', item.listPriceWithoutTaxValue || '');
        fragment.setAttribute('data-price-value', item.listPriceValue || '');
        fragment.setAttribute('data-product-discount', item.salePrice ? '1' : '0');
        return fragment;
    }

    async function clickHandler(target, item) {
        const preloader = Preloader(target);
        preloader.show();
        const orderInfo = {
            skuId: item.skuId,
            productId: item.productId,
            quantity: 1,
        };

        try {
            const order = await config.requestFunction.commit(orderInfo);
            if (!order.success) {
                throw {
                    type: 'CART_ERROR',
                    initialErrorObject: order,
                };
            }
            const cardElement = document.querySelector(`.cys-card[data-sku-id=${item.skuId}]`);
            const button = cardElement.querySelector('button');
            button.textContent = getProductData().msgAddedText;
            button.classList.remove('btn-primary');
            button.classList.add('cys-btn-added');
            button.setAttribute('disabled', true);
            config.requestFunction.onSuccess(order);
        } catch (error) {
            config.requestFunction.onError(error);
        }
        preloader.hide();
    }

    let delegateAddToCartClick = () => {};

    function render(items) {
        placeSliderShadow(items.length > 2);
        const isUnavailableItemExist = items.some(item => item.unavailable);
        if (isUnavailableItemExist) {
            wrapperElement.classList.add('cys-with-availables');
        }
        carouselElement.innerHTML = '';
        carouselElement.appendChild(renderListItems(items, renderItem));

        delegateAddToCartClick = event => {
            const selectedItem = items[event.target.dataset.itemIndex];
            if (selectedItem !== void 0) {
                clickHandler(event.target, selectedItem);
            }
        };
        carouselElement.addEventListener('click', delegateAddToCartClick);
    }

    function detach() {
        carouselElement.removeEventListener('click', delegateAddToCartClick);
    }

    return {
        render: render,
        detach: detach,
    };
}

export function CYS(siteID) {
    var SITE_ID = siteID;

    const DICTIONARY = {
        ...{
            msgWithTax: '',
            msgQtyMobile: '',
            resellerPriceLabel: '',
        },
        ...document.querySelector('.js-cys-container').dataset,
    };

    var Carousel = CarouselFactory({
        targetElement: '.slider',
        parentContainer: '#cys-products',
    });

    var ErrorComponent = new GlobalNotification('error');

    var CarouselRenderer = CarouselItemsRenderer({
        dict: DICTIONARY,
        urlResolver: resolveUrl,
        carouselElement: '#cys-products .slider',
        wrapper: '.cys-carousel',
        requestFunction: {
            commit: addToCartRequest,
            onSuccess: setCartInformation,
            onError: function(error) {
                ErrorComponent.show(
                    error.initialErrorObject.msg,
                    document.querySelector('.cys-table')
                );
            },
        },
    });

    var Popup = PopupFactory({
        targetElement: '.js-cys-container',
        closeElement: '.js-cys-close, .js-cys-shadow, .cys-button-continue',
        onDestroy: function() {
            CarouselRenderer.detach();
            Carousel.destroy();
            ErrorComponent.hide();
        },
    });

    async function getCYSRequest(orderInfo) {
        const url = makeUrl(
            `/rest/model/atg/commerce/order/purchase/CartModifierActor/getCysOptionSkus?pushSite=${SITE_ID}`
        );
        try {
            const { data: response } = await Axios.post(url, {
                skuId: orderInfo.skuId,
            });
            if (response.success === 'false') {
                throw new Error('Some Error while get options');
            }
            if (!shouldShowCYSPopup(response.options)) {
                throw new Error('do not display popup, because there are no items in it');
            }
            const body = document.querySelector('.cys-body');
            if (body) {
                body.setAttribute('data-requested-cys', orderInfo.skuId);
            }
            return {
                success: true,
                items: response.options,
            };
        } catch (error) {
            return {
                success: false,
                msg: error,
            };
        }
    }

    const addToCart = async orderInfo => {
        const preloader = Preloader(document.getElementById('add-to-cart'));
        preloader.show();
        try {
            const orderResponse = await addToCartRequest(orderInfo);
            if (!orderResponse.success) {
                throw {
                    type: 'CART_ERROR',
                    initialErrorObject: orderResponse,
                };
            }
            const cysResponse = await getCYSRequest(orderInfo);
            if (!cysResponse.success) {
                throw {
                    type: 'CYS_ERROR',
                    initialErrorObject: cysResponse,
                };
            }
            renderOrderItems({
                items: orderResponse.order,
                skuID: orderInfo.skuId,
                withTax: orderResponse.isPriceWithTax,
            });
            CarouselRenderer.render(cysResponse.items);
            setCartInformation(orderResponse, false);
            Popup.show();
            Carousel.create(0, cysResponse.items.length);
        } catch (error) {
            switch (error.type) {
                case 'CART_ERROR': {
                    ErrorComponent.show(
                        error.initialErrorObject.msg,
                        document.querySelector('.main-wrapper')
                    );
                    break;
                }
                case 'CYS_ERROR': {
                    window.gotoCart();
                    break;
                }
                default: {
                    console.error(error);
                }
            }
        }
        preloader.hide();
    };

    function shouldShowCYSPopup(cysItems) {
        try {
            return cysItems.length > 1;
        } catch (e) {
            return false;
        }
    }

    function renderOrderItems(renderConfig) {
        const orderToDisplay = renderConfig.items
            .filter(product => product.skuId === renderConfig.skuID)
            .map(item => ({
                ...item,
                withTax: Boolean(renderConfig.withTax),
            }));
        var orderItemsNodes = renderListItems(orderToDisplay, renderOrderItem);
        var $container = $('#cys-items');
        $container.empty();
        $container.append(orderItemsNodes);
    }

    function renderOrderItem(orderItem) {
        const template = `
            <div class="cys-table-img"><img src="${orderItem.imageUrl}" alt="${
            orderItem.productDisplayName
        }" /></div>
            <div class="cys-table-info">
                <div class="cys-table-info-column cys-product-info">
                    <div class="cys-table-title">${orderItem.productDisplayName}</div>
                    <div class="cys-table-sku">${orderItem.skuId.slice(4)}</div>
                </div>
                <div class="cys-table-info-column cys-qty-info">
                    <div class="cys-table-qty"><span>${orderItem.quantity}</span></div>
                </div>
                <div class="cys-table-info-column cys-price-info">
                    <div class="cys-table-qty-mobile">
                        <span>${DICTIONARY.msgQtyMobile}:</span><span>${orderItem.quantity}</span>
                    </div>
                    <span class="cys-striked-price">${
                        orderItem.partnerDisplayName ? orderItem.listPrice : ''
                    }</span><span class="cys-table-price">${orderItem.salePrice ||
            orderItem.listPrice}</span>
                    ${
                        orderItem.withTax
                            ? `<div class="cys-table-vat">${DICTIONARY.msgWithTax}</div>`
                            : ''
                    }
                    ${
                        orderItem.partnerDisplayName
                            ? `<div class="cys-reseller-price-label">
                                ${orderItem.partnerDisplayName} ${DICTIONARY.resellerPriceLabel}
                               </div>`
                            : ''
                    }
                </div>
            </div>
        `;

        const fragment = document.createElement('div');
        fragment.className = 'cys-table-row';
        fragment.innerHTML = template;
        return fragment;
    }
    function setCartInformation(info, minicartOnly) {
        if (!minicartOnly) {
            var $title = $('.cys-header .cys-title');
            var text = $title.text().match(/^\d*\s?(.*)/m)[1];
            $title.text(info.initialQuantity + ' ' + text);
        }

        $('.js-subtotal-amount').text(info.total);

        updateMiniCart(info.total);
    }

    return addToCart;
}
